import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';
//

import Page404 from './pages/Page404';
import PokedexPage from './pages/PokedexPage';
import DashboardAppPage from './pages/DashboardAppPage';
import AnalyticsPage from './pages/AnalyticsPage';
import CountersFinderPage from './pages/CountersFinderPage';

// ----------------------------------------------------------------------

export default function Router() {
  const routes = useRoutes([
    {
      path: '/',
      element: <DashboardLayout />,
      children: [
        { element: <DashboardAppPage />, index: true },
        { path: 'pokedex', element: <PokedexPage /> },
        { path: 'analytics', element: <AnalyticsPage /> },
        { path: 'counters-finder', element: <CountersFinderPage /> },
      ],
    },
    {
      element: <SimpleLayout />,
      children: [
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
  ]);

  return routes;
}
